/**
 * Budgets CRUD — Firestore + dev mode mirror.
 */
import { addDoc, collection, deleteDoc, doc, updateDoc } from 'firebase/firestore';
import { db, COLLECTIONS, IS_DEV_MODE } from '../../lib/firebase';
import { useBudgetsStore, type Budget } from './budgetsStore';
import { generateId } from '../../lib/utils';

export interface NewBudgetInput {
  familyId: string;
  walletId: string;
  categoryId: string;
  amount: number;
  period: 'monthly' | 'weekly' | 'yearly';
  alertAt: number;
}

export async function createBudget(input: NewBudgetInput): Promise<string> {
  if (IS_DEV_MODE) {
    const b: Budget = {
      id: generateId('budget'),
      ...input,
    };
    const store = useBudgetsStore.getState();
    store.setBudgets([...store.budgets, b]);
    return b.id;
  }
  const ref = await addDoc(collection(db, COLLECTIONS.budgets), input);
  return ref.id;
}

export async function updateBudget(id: string, patch: Partial<NewBudgetInput>): Promise<void> {
  if (IS_DEV_MODE) {
    const store = useBudgetsStore.getState();
    store.setBudgets(store.budgets.map((b) => (b.id === id ? { ...b, ...patch } : b)));
    return;
  }
  await updateDoc(doc(db, COLLECTIONS.budgets, id), patch);
}

export async function deleteBudget(id: string): Promise<void> {
  if (IS_DEV_MODE) {
    const store = useBudgetsStore.getState();
    store.setBudgets(store.budgets.filter((b) => b.id !== id));
    return;
  }
  await deleteDoc(doc(db, COLLECTIONS.budgets, id));
}
